/**
 * English bundle (en_BE): union of keys from fr_FR, fr_BE, it_IT, pt_PT, es_ES, nl_NL, nl_BE.
 */
import { getStaticDocUrl } from "../utils/staticDocumentUrls"
import React, { useState } from "react"
import { Button, Col, Row } from "react-bootstrap"
import Modal from "react-bootstrap/Modal"

/** Samsung ES opt-in copy (Spanish), inlined for en_BE bundle — same UX as es-ES.js */
const SamsungESOptin1 = () => {
  const [show, setShow] = useState(false)

  return (
    <>
      <>
        Acepto el envio de comunicaciones comerciales sobre productos financieros y de seguros de entidades del Grupo
        BNP Paribas en España previa realizacíon de un perfilado de mis datos y consulta a sistema externos de
        información crediticia.
        <u onClick={() => setShow(true)} className="clickable">
          Más información
        </u>
      </>
      <Modal show={show} onHide={() => setShow(false)} className="modal-info">
        <Modal.Body>
          <div id="dropin-container">
            Consiento expressamente que Banco Cetelem, S.A.U. pueda enviarme comunicaciones comerciales de productos
            financieros y de seguros de entidades del Gtupo BNP Paribas en España y. en especial de ofertas de seguros
            mediados por Banco Cetelem S.A.U, OBSV, mediante qualquier medio, includos electrónicos, tales com SMS, MMS,
            email, whatsapp, etc, previo perfilado de mis datos personales y el enriquecimento de los mismos mediante
            bases de datos externas, así como la consulta a ficheros de solvencia patrimonial y crédito mientras esté
            vigente el contrato y durante los 24 meses siguientes a la finalización del mismo.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Row className="justify-content-md-center">
            <Col md={6} lg={6}>
              <Button variant="outline-primary" onClick={() => setShow(false)}>
                Acceptar
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  )
}

const SamsungESOptin2 = () => {
  const [show, setShow] = useState(false)

  return (
    <>
      <>
        Acepto el envío de comunicaciones comerciales sobre productos de terceras entidades con las que Banco Cetelem
        S.A.U. mantenga acuerdos comerciales, previo realizacíon de un perfilado de mis datos y consulta a sistemas
        externos de informacíon crediticia.
        <u onClick={() => setShow(true)} className="clickable">
          Más información
        </u>
      </>
      <Modal show={show} onHide={() => setShow(false)} className="modal-info">
        <Modal.Body>
          <div id="dropin-container">
            Consiento expresamente que Banco Cetelem S.A.U. pueda enviarme comunicaciones comerciales de terceras
            entidades con las que Banco Cetelem S.A.U. mantenga acuerdos comerciales, de los sectores finianciero, ocio,
            formación, gran consumo, editorial, automoción, energia, agua, electrodomésticos, informática, muebles,
            cocina, textil deporte y reformas del hogar, y en especial de ofertas de seguros mediados por Banco Cetelem,
            S.A.U. OBSV, mediante qualquer medio, incluidos electrónicos, tales como SMS, MMS, email, whatsapp, etc,
            previo perfilado de mis datos personales y el enriquecimiento de los mismos mediante bases de datos
            externas, así como la consulta a ficheros de solvencia patrimonial y crédito mientras esté vigente el
            contrato y durante los 24 meses siguientes a la finalización del mismo.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Row className="justify-content-md-center">
            <Col md={6} lg={6}>
              <Button variant="outline-primary" onClick={() => setShow(false)}>
                Acceptar
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export const en_BE = {
  "Back to shop": "Back to shop",
  "Redirecting to Samsung shop shortly": "We will redirect you to the Samsung shop shortly.",
  button_back_shop: "Back to basket",
  button_back_to_my_basket: "Return to my basket",
  Back: "Back",
  Validate: "Confirm",
  "Your transaction is being finalized.": "Your transaction is being finalized.",
  button_cancel: "Cancel",
  button_close: "Close",
  button_send_upload: "Send",
  Submit_BPLS: "Submit my application",
  "Select...": "Select...",
  Choose: "Choose",
  Start: "Start",
  modifier_donnees: "Edit your details",
  bpls_onboarding_validation_button: "Complete your details",
  "thanks you for your request.": "thanks you for your request.",
  ACKNOWLEDGMENT_RECEIPT: "Acknowledgement of receipt",
  OTHER: "Other",
  DIAGNOSTIC_ASSESSMENT: "Diagnostic assessment",
  DELIVERY_FORM: "Delivery note",
  RENT_FORM: "Rental form",
  PRODUCT_PHOTO: "Product photo(s)",
  RETURN_FORM: "Return form",
  WITHDRAWAL_FORM: "Withdrawal form",
  COURIER: "Mail",
  DISTRIBUTOR_INVOICE: "Distributor invoice",
  ADDRESS_PROOF: "Proof of address",
  EXTERNAL_PAYMENT_PROOF: "External payment proof",
  SEPA_MANDATE: "SEPA mandate",
  Services: "Services",
  Informations: "Information",
  "My informations": "My informations",
  Summary: "Summary",
  "My summary": "My summary",
  Contracts: "Contract",
  "Back to basket": "Back to basket",
  Basket: "Basket",
  Ma_demande_location: "My rental application",
  Accessories: "Accessory(ies)",
  "Promo code": "Promo code",
  on: "of",
  months: "months",
  Included: "Included in the offer",
  "Shipping fees": "Shipping fees",
  Upfront: "1st payment",
  "My upfront": "My upfront",
  Rent: "Rent",
  "/month": "/month",
  months_uppercase: " Months",
  YYYY: "YYYY",
  "YYYY/MM/DD": "YYYY/MM/DD",
  "DD/MM/YYYY": "DD/MM/YYYY",
  "including services pack at": "including services pack at",
  "including services at": "including services at",
  obligatorystar: "*",
  "including insurance at": "including insurance at",
  renouvellementProduit: "Product renewal",
  civility_mr: "Mr",
  civility_mrs: "Mrs",
  "TV Comfort Pack": "TV Comfort Pack",
  "Breakdown warranty": "Breakdown warranty",
  "Home delivery": "Home delivery",
  "Early renewal from the 24th rental instalment": "Early renewal from the 24th rental instalment",
  "Home pickup (trade-in)": "Home pickup (trade-in)",
  "Read the general terms of long-term rental and TV services":
    "Read the general terms of long-term rental and TV services",
  "Supporting documents requested": "Supporting documents requested",
  "Supporting documents requested for subscription": "Supporting documents requested for subscription",
  "A bank card in your name": "A bank card in your name",
  "Your mobile phone": "Your mobile phone",
  "A bank identity statement in your name": "A bank identity statement in your name",
  "My RIB": "My RIB",
  "Your banking credentials": "Your banking credentials",
  "Mon relevé bancaire": "My bank statement",
  "A valid ID in your name": "A valid ID in your name",
  "A valid ID for identity verification through biometric authentication":
    "A valid ID for identity verification through biometric authentication",
  "My ID": "My ID",
  "A PC or smartphone camera is required to take a photo of your ID and a video of your face":
    "A PC or smartphone camera is required to take a photo of your ID and a video of your face",
  bpls_onboarding_id: "ID document",
  bpls_onboarding_company_rib: "Your company bank details (RIB)",
  "My valid ID": "My valid ID",
  "Proof of address of less than 3 months": "Proof of address of less than 3 months",
  "Proof of address of less than 6 months": "Proof of address of less than 6 months",
  "A mobile phone bill less than 6 months old in your name": "A mobile phone bill less than 6 months old in your name",
  "Proof of income": "Proof of income",
  "Energy, telephone or internet bill in your name less than 6 months old":
    "Energy, telephone or internet bill in your name less than 6 months old",
  "My proof of amount income": "My proof of amount income",
  "My proof of address": "My proof of address",
  "Then i finalize my order in shop under 5 days, bringing with me those 4 proofs":
    "Then i finalize my order in shop under 5 days, bringing with me those 4 proofs",
  "My identification": "My identification",
  "Only if your bancary document's address is different than the one you will enter":
    "Only if your bancary document's address is different than the one you will enter",
  "Only if my RIB's address is different from my current address":
    "Only if my RIB's address is different from my current address",
  "Enter the informations that will allow us to identify you.":
    "Enter the informations that will allow us to identify you.",
  "Start your location online then meet us in our sellpoint.":
    "Start your location online then meet us in our sellpoint.",
  "by entering my personnal informations": "by entering my personnal informations",
  "Want to rent my product ? No problem ! It only takes a few minutes to subscribe online":
    "Want to rent my product ? No problem ! It only takes a few minutes to subscribe online",
  "Here are the steps to follow for your rental request !": "Here are the steps to follow for your rental request !",
  "Then i finalize my order in shop under 5 days, bringing with me those 3 proofs":
    "Then i finalize my order in shop under 5 days, bringing with me those 3 proofs",
  "To complete your subscription request, bring the following items, all of which must be in your name :":
    "To complete your subscription request, bring the following items, all of which must be in your name :",
  "Here are the steps to follow to make your rental request":
    "Here are the steps to follow to make your rental request",
  "The online subscription procedure is fully dematerialized.":
    "The online subscription procedure is fully dematerialized.",
  "The online subscription procedure is completely dematerialized. The signing of your contract and the sending of your supporting documents will be done electronically.":
    "The online subscription procedure is completely dematerialized. The signing of your contract and the sending of your supporting documents will be done electronically.",
  "The signing of your contract and the downloading of your supporting documents will be done by electronic way.":
    "The signing of your contract and the downloading of your supporting documents will be done by electronic way.",
  "Select your services and customize the options of your rental contract.":
    "Select your services and customize the options of your rental contract.",
  "Select your services, durations and customize the options of your rental contract.":
    "Select your services, durations and customize the options of your rental contract.",
  "Pay by credit card the 1st installment of your rental contract.":
    "Pay by credit card the 1st installment of your rental contract.",
  "through bank card to reserve my product": "through bank card to reserve my product",
  "Check and complete your personal information which will appear on your contract.":
    "Check and complete your personal information which will appear on your contract.",
  "which will appear on my location's contract": "which will appear on my location's contract",
  "Validate your personal information and your rental request.":
    "Validate your personal information and your rental request.",
  "which allow me to validate my informations and my rent request":
    "which allow me to validate my informations and my rent request",
  "Download your supporting documents and sign your dematerialized contract.":
    "Download your supporting documents and sign your dematerialized contract.",
  "Obtain acceptance in principle then finalize your order in the store of your choice.":
    "Obtain acceptance in principle then finalize your order in the store of your choice.",
  "I get a principle acceptation to rent my product": "I get a principle acceptation to rent my product",
  "To complete your subscription request, have the following information ready:":
    "To complete your subscription request, have the following information ready:",
  "Only if the address of your RIB differs from your current address":
    "Only if the address of your RIB differs from your current address",
  "Only if the address of your RIB differs from your current address or the amount of product > 3000€ttc.":
    "Only if the address of your RIB differs from your current address or the amount of product > 3000€ttc.",
  "To speed up the study of your file, prefer an invoice indicating your telephone number entered in the form":
    "To speed up the study of your file, prefer an invoice indicating your telephone number entered in the form",
  bpls_onboarding_first_title: "Complete your Samsung Rent+ Pro order in 3 steps: ",
  bpls_onboarding_second_title: "Please have the following ready: ",
  bpls_onboarding_step_client_title: "Complete",
  bpls_onboarding_step_informations_paragraph: "your details",
  bpls_onboarding_step_summary_title: "Submit",
  bpls_onboarding_step_summary_paragraph: "your rental application",
  bpls_onboarding_step_loader_title: "E-sign",
  bpls_onboarding_step_loader_paragraph: "your contract",
  "Gain peace of mind by protecting your product throughout the rental period.":
    "Gain peace of mind by protecting your product throughout the rental period.",
  "Read the insurance notice": "Read the insurance notice",
  "Full warranty": "Full warranty",
  Upgrade: "Renewal",
  "Dedicated customer service": "Dedicated customer service",
  "Accidental breakage": "Accidental breakage",
  "Accidental oxidation": "Accidental oxidation",
  "Accidental action": "Accidental action",
  "Global coverage": "Global coverage",
  "No deductible applied": "No deductible applied",
  "14 days withdrawal period": "14 days withdrawal period",
  "Telephone assistance 6 days a week": "Telephone assistance 6 days a week",
  Pickpocketing: "Pickpocketing and snatch theft",
  "Theft by assault or break-in": "Theft by assault or break-in",
  "Fraudulent use": "Fraudulent use",
  None: "None",
  Breakage: "Breakage",
  "Breakage and theft": "Breakage and theft",
  "or a rent of ": "or a rent of ",
  "I acknowledge having read and accept the general conditions of the long-term rental contract offer and the service contract.":
    "I acknowledge having read and accept the general conditions of the long-term rental contract offer and the service contract.",
  "I request the start of the execution of my long-term rental contract with the lessor and my service contract before the expiration of the 14-day withdrawal period.":
    "I request the start of the execution of my long-term rental contract with the lessor and my service contract before the expiration of the 14-day withdrawal period.",
  "I confirm that I do not choose optional insurance and assume the risk of breakage or theft during my long-term rental contract.":
    "I confirm that I do not choose optional insurance and assume the risk of breakage or theft during my long-term rental contract.",
  "I confirm my subscription to breakage insurance and acknowledge having read the insurance information notice.":
    "I confirm my subscription to breakage insurance and acknowledge having read the insurance information notice.",
  "By checking this box, I authorize Cardif Assurances Risques Divers to use my email address for the execution of my contract. However, I recognize that certain documents must be sent to you in the original and that you will inform me if the case arises. I note that this data (email address) will not be used for commercial solicitation purposes, unless I have expressly consented otherwise. I have the right to oppose exchanges by e-mail at any time by sending my request to data.protection@cardif.com or to CARDIF Assurances Risques Divers - Claims quality department - Prévoyance SH 123- 8 rue du Port - 92 728 Nanterre Cedex.":
    "By checking this box, I authorize Cardif Assurances Risques Divers to use my email address for the execution of my contract. However, I recognize that certain documents must be sent to you in the original and that you will inform me if the case arises. I note that this data (email address) will not be used for commercial solicitation purposes, unless I have expressly consented otherwise. I have the right to oppose exchanges by e-mail at any time by sending my request to data.protection@cardif.com or to CARDIF Assurances Risques Divers - Claims quality department - Life insurance division SH 123, 8 rue du Port - 92728 Nanterre Cedex.",
  'Up2You\'s breakage and thief protection is a collective damage insurance (number 674) contract subscribed by Samsung Electronics France, society with a capital of 27 000 000 euros – 334 367 497 RCS Bobigny – Siège social 1, rue fructidor 93484 Saint-Ouen auprès de CARDIF - Assurances Risques Divers - S.A. (society with a capital of 16 875 840 euros) 308 896 547 RCS Paris - Siège social : 1, Boulevard Haussmann 75009 Paris - Entreprise ruled by the insurance code, here called "CARDIF"':
    'Up2You\'s breakage and theft protection is a collective damage insurance (policy no. 674) contract taken out by Samsung Electronics France, a company with share capital of EUR 27,000,000 – 334 367 497 RCS Bobigny – registered office: 1, rue Fructidor, 93484 Saint-Ouen-sur-Seine, with CARDIF - Assurances Risques Divers - S.A. (company with share capital of EUR 16,875,840) 308 896 547 RCS Paris – registered office: 1, Boulevard Haussmann, 75009 Paris, a company governed by the French Insurance Code, hereinafter referred to as "CARDIF"',
  "Up2YOu Location's breakage and thief insurance is distributed as an accessory relatively to it main commercial activity by Samsung Electronics France by the way of Garantie-privée SAS, insurance society with a capital of 60 000 € - 521 279 737 RCS Bordeaux, - Siège social : 7-9 allée Haussmann 33300 Bordeaux, registered to l’ORIAS ( www.orias.fr ) under the reference 100 557 38.":
    "Up2You Location's breakage and theft insurance is distributed as an ancillary product to its main commercial activity by Samsung Electronics France through Garantie-privée SAS, an insurance company with share capital of EUR 60,000 - 521 279 737 RCS Bordeaux - registered office: 7-9 allée Haussmann, 33300 Bordeaux, registered with ORIAS (www.orias.fr) under reference 100 557 38.",
  "Up2You location breakage and thief contract' sinister handling is the responsability of Grantie-Privée, insurance broker":
    "Claims handling for the Up2You location breakage and theft contract is the responsibility of Garantie-Privée, insurance broker",
  "You have a 14-day cooling-off period for a remote rental request from the conclusion of your long-term rental contract. Non-contractual photo.":
    "You have a 14-day cooling-off period for a remote rental request from the conclusion of your long-term rental contract. Non-contractual photo.",
  "You have not chosen an insurance option": "You have not chosen an insurance option",
  "Be aware that in case of breakage or theft, you will have to pay for repairs to the product or its replacement. Remember to protect your device for peace of mind, as the breakdown guarantee does not cover breakage or theft.":
    "Please note that in the event of breakage or theft, you will have to pay for repairs or replacement of the product. Remember to protect your device for peace of mind, as the breakdown warranty does not cover breakage or theft*.",
  "*see general conditions in the insurance notice": "*see general conditions in the insurance notice",
  "first installment of your rental contract": " Pay by bank card for the 1st payment of your lease",
  adyen_first_payment_intro:
    "We kindly ask you to make a first payment equal to the one-off fees under your Private Lease contract. That is:",
  adyen_first_payment_review:
    "After your first payment is received and your application is submitted, Evollis will assess your application. Evollis may ask you to provide additional information. Only once Evollis has definitively accepted your application will the Private Lease contract take effect. If you are not eligible for Private Lease, the first payment will be refunded to your account. You also have the right to terminate the contract free of charge within 14 days of submitting your application; in that case the first payment will also be refunded.",
  adyen_first_payment_provider:
    "The first payment will be processed via iDEAL by our service provider Adyen. Adyen B.V. is a private limited liability company registered with the Chamber of Commerce under number 34259528, with its registered office at Simon Carmiggeltstraat 6-50, 1011 DJ Amsterdam, Netherlands.",
  "Cards accepted": "Cards accepted",
  "Cards not accepted": "Cards not accepted",
  "Systematic authorization cards (Electron, Maestro, pre-paid or rechargeable), American Express and e-CB.":
    "Systematic authorisation cards (Electron, Maestro, prepaid or reloadable), American Express and e-CB.",
  "The 1st payment of ": "The 1st payment of ",
  "Systematically authorized cards (such as Electron, Maestro, prepaid, rechargeable), e-CB and American Express.":
    "Systematically authorized cards (such as Electron, Maestro, prepaid, rechargeable), e-CB and American Express.",
  "Upfront amount of your leasing contract": "Upfront amount of your leasing contract",
  "Card number": "Card number",
  MM: "MM",
  CB: "Card",
  Visa: "Visa",
  Mastercard: "Mastercard",
  "Your credit card is expired": "Your card has expired",
  "Expiration date": "Expiry date",
  CVV: "CVV",
  "I, undersigned $ certify that I am the holder of the bank card used for the request for payment of my 1st payment.":
    [
      "I, undersigned ",
      " certify that I am the holder of the bank card used for the request for payment of my 1st payment."
    ],
  "Secured payment": "Secure payment",
  "Payment validation": "Payment validation",
  "Validation de votre paiement en cours": "Validating your payment",
  "validate the payment authorization": "Confirm payment authorisation",
  "Your card has been declined. Please check the accuracy of the information entered. You can also contact your bank to verify that it is not blocking payment.":
    "Your card was declined. Please check that the details entered are correct. You can also contact your bank to check that it is not blocking the payment.",
  "penalties for contract1": "penalties for contract1",
  "penalties for contract2": "penalties for contract2",
  "penalties for contract3": "penalties for contract3",
  "penalty click": "penalty click",
  "ademe number": "ademe number",
  "This step only constitutes a request for authorization of payment.":
    "This step is only a request for payment authorisation.",
  " The 1st payment of ": " The 1st payment of ",
  " by credit card will only be effective after signing your rental contract and downloading your supporting documents.If your rental request is subsequently refused by the Lessor following its study, then this amount will be immediately refunded.":
    " by bank card will only be taken after you download your supporting documents and sign your rental contract. If your rental application is subsequently refused by the lessor after review, this amount will be refunded immediately.",
  "Bank Seniority": "Year you joined your current bank",
  "My identity": "My identity",
  "My Leader identity": "My Leader identity",
  "My coordinates": "My coordinates",
  "Leader coordinates": "Leader coordinates",
  "My situation": "My situation",
  "My budget": "My budget",
  "The information below is necessary for our renter for the constitution of your rental file.":
    "The information below is necessary for our renter for the constitution of your rental file.",
  "To meet our eligibility conditions, you must have regular activity income and not have any current payment incidents.":
    "To meet our eligibility conditions, you must have regular activity income and not have any current payment incidents.",
  Identity: "Identity",
  Title: "Title",
  Mr: "Mr",
  Ms: "Ms",
  "Last name": "Last name",
  "leader first name": "Executive’s first name",
  "leader name": "Executive’s last name",
  "Last second name": "Last second name",
  "Maiden name": "Birth name",
  "If you are not married, enter your name again.": "If your current name is your birth name, please enter it here.",
  "First name": "First name",
  Address: "Address",
  "Enter the address that will appear on your contract.": "Enter the address that will appear on your contract.",
  "Address 2": "Address line 2 (optional)",
  Locality: "Locality (optional)",
  Zip: "Postcode",
  City: "City",
  Birth: "Birth",
  Birthdate: "Date of birth",
  "Department of birth": "Department of birth",
  "City of birth": "City of birth",
  "Country of birth": "Country of birth",
  Citizenship: "Nationality",
  Contact: "Contact",
  Mobile: "Mobile number",
  Email: "Email",
  Occupation: "Occupation",
  "Since...": "Since...",
  " since ": " since ",
  Finances: "Finances",
  "Your net monthly income": "Your net monthly income",
  "over 12 months": "over 12 months",
  "over 13 months": "over 13 months",
  "over 14 months": "over 14 months",
  "over 15 months": "over 15 months",
  "over 16 months": "over 16 months",
  "Other monthly income": "Other monthly income",
  "Property income or alimony paid": "Property income or alimony received",
  "Your share of monthly charges": "Your share of monthly expenses",
  "Rent or mortgage": "Rent or mortgage",
  "Rent or mortgage EVO": "Rent(s) or mortgage payment(s), non-mortgage credit, childcare costs",
  "Net monthly income tooltip":
    "Salary + bonuses, pension(s) and pre-retirement, self-employment income, pensions, etc.",
  "Other monthly charges": "Other monthly expenses",
  "Credit (excluding mortgage) and / or alimony paid": "Credit (excluding mortgage) and/or alimony paid",
  Housing: "Housing",
  "Family situation": "Family situation",
  "Number of dependent children": "No. of children",
  "Bank account": "Bank account",
  IBAN: "IBAN",
  "IBAN bpls": "Company IBAN",
  firm_bloc_title: "Your company",
  Company: "Your company",
  "Company name": "Company name",
  "Company siren": "Company siren",
  "Company siret": "SIRET number",
  "Company siret infos": "The SIRET number has 14 digits",
  "Executive birthdate": "Executive’s date of birth",
  "Executive title": "Executive title",
  "Executive lastname": "Executive lastname",
  "Executive firstname": "Executive firstname",
  "Executive birthdate infos": "Enter the date of birth of the company’s main executive.",
  "Company isSameAddress": "Company isSameAddress",
  Signatory: {
    propsValues: (props) => {
      const { data } = props
      return `Signatory ${data}`
    }
  },
  "Signatory tooltip":
    "To validate your financing application, please complete your signatory details. Signatories are people authorised to sign on behalf of the company. This information is used only for electronic signature of your contract.",
  "Executive civility tooltip": "Executive civility tooltip",
  "Add signatory": "Add signatory",
  "Remove signatory": "Remove a signatory",
  "Signatory name": "Signatory’s last name",
  "Signatory first name": "Signatory’s first name",
  "Signatory birthdate": "Signatory’s date of birth",
  "Signatory email": "Signatory’s email",
  "Signatory email info":
    "The contract will be sent to this email. It must be a natural person’s email, not a generic mailbox.",
  "Signatory mobile phone": "Signatory’s mobile number",
  "Signatory mobile phone infos":
    "A code will be sent by SMS to authenticate the signatory and validate their electronic signature.",
  Bank: "Your bank details",
  "Company bank details": "Your company’s bank details",
  "Bank account owner": "Name of the company account holder",
  Adresses: "Your addresses",
  "Shipping address": "Delivery address",
  "Shipping address 2": "Delivery address line 2",
  "Billing address 2": "Billing address line 2",
  "Billing adress": "Billing address",
  within: "of",
  "Edit my data": "Edit my details",
  "We ask your consent for all the purposes described in data processing :":
    "We ask your consent for all the purposes described in data processing :",
  "I agree that the start date of my Rental contract, end date of my Rental contract, renewal date of my Rental contract and that the duration of my Rental contract be sent to Rue du Commerce in order to allow manage my Rental contract from my Rue du Commerce customer area.":
    "I agree that the start date of my Rental contract, end date of my Rental contract, renewal date of my Rental contract and that the duration of my Rental contract be sent to Rue du Commerce in order to allow manage my Rental contract from my Rue du Commerce customer area.",
  "Je donne par la présente mon consentement explicite au traitement de mes données personnelles aux fins spécifiées dans la Politique de confidentialité":
    "I hereby give my explicit consent to the processing of my personal data for the purposes specified in the Privacy Policy",
  "Je m'oppose à la réception d'offres commerciales par voie postale ou téléphonique de la part des sociétés de groupe BNP Paribas Personal Finance.":
    "I oppose the receipt of commercial offers by post or telephone from BNP Paribas Personal Finance group companies.",
  "J'accepte de recevoir par voie électronique des offres commerciales de la part des sociétés du groupe BNP Paribas Personal Finance.":
    "I agree to receive electronically commercial offers from companies in the BNP Paribas Personal Finance group.",
  /* Même libellé sans point final (ex. summary.Optin1 côté API bank) */
  "J'accepte de recevoir par voie électronique des offres commerciales de la part des sociétés du groupe BNP Paribas Personal Finance":
    "I agree to receive electronically commercial offers from companies in the BNP Paribas Personal Finance group.",
  /* Variante apostrophe typographique U+2019 */
  "J\u2019accepte de recevoir par voie électronique des offres commerciales de la part des sociétés du groupe BNP Paribas Personal Finance.":
    "I agree to receive electronically commercial offers from companies in the BNP Paribas Personal Finance group.",
  "J\u2019accepte de recevoir par voie électronique des offres commerciales de la part des sociétés du groupe BNP Paribas Personal Finance":
    "I agree to receive electronically commercial offers from companies in the BNP Paribas Personal Finance group.",
  "Read each document (tab), download your supporting documents. You will be able to accept the conditions of the contract by checking the boxes and electronically sign your contract with a code that you will receive by SMS.":
    "Read each document (tab), download your supporting documents. You will be able to accept the conditions of the contract by checking the boxes and electronically sign your contract with a code that you will receive by SMS.",
  "Proceed with identity verification through biometric authentication and upload your supporting documents. Review each document (tab), then accept the contract terms by ticking the checkboxes and sign your contract electronically using a code that you will receive via SMS.":
    "Proceed with identity verification through biometric authentication and upload your supporting documents. Review each document (tab), then accept the contract terms by ticking the checkboxes and sign your contract electronically using a code that you will receive via SMS.",
  "Your product will be delivered to you after the final acceptance of the long-term rental contract and upon receipt of supporting documents by the rental company.":
    "Your product will be delivered to you after the final acceptance of the long-term rental contract and upon receipt of supporting documents by the rental company.",
  "Request sent": "Your rental application is complete.",
  "Your file number is": "Your file number is",
  "Now, we need to review it and determine if you are eligible for our offer. A response will be provided to you within 48 hours.":
    "We will review your application and commit to responding within a maximum of 24 hours (business day).",
  "BPLS confirmation text":
    "You just need to e-sign your contract to trigger delivery of your order. You will receive an email from our partner DocuSign to e-sign your contract.",
  "Upon confirmation of acceptance of your file, you can go to the store to get your product.":
    "Upon confirmation of acceptance of your file, you can go to the store to get your product.",
  "Thank you for your trust and see you soon !": "Thank you for your trust — see you soon!",
  lets_go: "Let’s go!",
  "Let's go ! I have ": "Let's go ! I have ",
  you_have_x_days_to: {
    propsValues: (props) => {
      const { offerDroppingDelay, shop } = props
      return `You have ${offerDroppingDelay} days to go to your ${shop} store to finalize your application with the following documents:`
    }
  },
  "days to go personally to a {store} store to finalize my request with the following documents:":
    "days to go personally to a {store} store to finalize my request with the following documents:",
  Acceptance: "Acceptance",
  "Acceptance in principle": "Acceptance in principle",
  "Your subscription request": "Your subscription request",
  "has been accepted in principle.": "has been accepted in principle.",
  "You have ": "You have ",
  " days": " days",
  "to go to your store in order to finalize your subscription request by bringing the following documents:":
    "to go to your store in order to finalize your subscription request by bringing the following documents:",
  "A confirmation email of your order": "A confirmation email of your order",
  "has just been sent.": "has just been sent.",
  "Request pre-accepted": "Your order has been accepted.",
  "Pre accepted paragraph one": {
    elementHtml: (
      <>
        Please remember to print the rental voucher and hand it to the customer. This rental voucher will also be sent
        by email.
      </>
    )
  },
  "Pre accepted paragraph two": {
    elementHtml: <></>
  },
  "Pre accepted paragraph three": {
    elementHtml: <small></small>
  },
  "Pre accepted paragraph four": {
    elementHtml: <>Give the customer the original product delivery note.</>
  },
  "Pre accepted paragraph five": {
    elementHtml: <>Upload the delivery receipt signed by the customer.</>
  },
  "Print the rental voucher": "Print the rental voucher",
  generate_delivery_voucher: "OK",
  voucher_ready:
    "Don't forget to print the rental voucher and hand it to the customer; it will also be sent to the customer by email.",
  error_voucher_retrieval: "An error occurred while retrieving the rental voucher.",
  "No rental voucher": "No rental voucher available",
  finalize_later: "Finalize later",
  pdi_retail_opl: "Order number",
  pdi_retail_store_id_label: "Store number",
  pdi_retail_partner_order_id_label: "Distributor order number*",
  pdi_retail_imei_marquage_label: "IMEI / marking number",
  pdi_retail_mm_order_digits: "Enter exactly 8 digits.",
  final_page_import_document: "Upload a document",
  upload_file_title: "Upload documents",
  upload_line_label: "Page",
  upload_button_line: "Choose a file",
  upload_line_no_upload: "No file selected",
  upload_button_add_document: "+ Add a document page",
  wrongFileExtensionMessage: "This file is not valid; please choose a JPG image or a PDF.",
  onlyAlphaNumericMessage: "The name must contain only alphanumeric characters.",
  fiveMegaBytesMaximumFileMessage: "The file exceeds the maximum allowed size of 5 MB.",
  upload_toast_success: "New documents imported successfully",
  upload_toast_fail: "Error while importing new documents: ",
  imei: "IMEI / Serial Number",
  numero_marquage: "Engraving / marking number",
  bill_number: "Invoice number",
  scoreLoaderTitle: "Your rental application is being processed",
  scoreLoaderSubtitle: "Please wait",
  scoreLoaderText: "You will receive a response shortly.",
  bplsPendingScoreTitle: "Your financing rental application is under review",
  bplsPendingScoreText: "We will get back to you very shortly by email.",
  bplsPendingScoreOrderSubtitle: "Your financing rental application",
  bplsPendingScoreOrderText: {
    propsValues: (props) => {
      const { opl, externalReference } = props
      return `N° demande ${externalReference} - ${opl}`
    }
  },
  bplsPendingScoreOrderTextDuration: {
    propsValues: (props) => {
      const { defaultDuration, monthlyTotalTaxesExcluded } = props
      return `Loyer ${defaultDuration} mois : ${monthlyTotalTaxesExcluded} € HT / mois.`
    }
  },
  bplsScoreOkTitle: "Your rental application is accepted. Your contract is ready to be e-signed",
  bplsScoreOkSubtitle: "Your financing rental application has been accepted.",
  bplsScoreOkText:
    "You just need to e-sign your contract to trigger delivery of your order. You will receive an email from our partner DocuSign to e-sign your contract.",
  spamWarningBpls: "If you do not receive an email in your inbox, please check your spam folder.",
  bplsScoreKoTitle: "Your rental application has been refused",
  bplsScoreKoSubtitle: "We regret to inform you that we cannot give a favourable response to your request.",
  bplsScoreKoText: "We invite you to return to your basket and select the purchase option to complete your order.",
  "AXA France IARD, a public limited company with capital of € 214,799,030, registered with the RCS of Nanterre under number 722 057 460 and whose registered office is 313 Terrasses de l'Arche 92727 Nanterre Cedex - Company governed by the Insurance Code and subject to to the control of the Prudential Supervisory Authority, 4 place de Budapest CS 92459 75436 Paris Cedex 09.":
    "AXA France IARD, a public limited company with capital of € 214,799,030, registered with the RCS of Nanterre under number 722 057 460 and whose registered office is 313 Terrasses de l'Arche 92727 Nanterre Cedex - Company governed by the Insurance Code and subject to to the control of the Prudential Supervisory Authority, 4 place de Budapest CS 92459 75436 Paris Cedex 09.",
  "GARANTIE PRIVEE.COM, simplified joint stock company with capital of 60,000 euros, insurance brokerage company registered in the Bordeaux Trade Register under number 521 279 737, and registered in the register of intermediaries under number ORIAS 10 055 738, Domiciled : Le Plaza II, 2 Place Ravezies, 33300 Bordeaux":
    "GARANTIE PRIVEE.COM, simplified joint stock company with capital of 60,000 euros, insurance brokerage company registered in the Bordeaux Trade Register under number 521 279 737, and registered in the register of intermediaries under number ORIAS 10 055 738, Domiciled : Le Plaza II, 2 Place Ravezies, 33300 Bordeaux",
  "The evaluation of your file is subject to automated processing which may lead to a refusal of your subscription request. You have the right to obtain human intervention, to express your point of view and to contest the decision by contacting us at the following address: Personal Finance Location - 62061 Arras - Cedex 9 or by email: serviceclientspflocation @ bnpparibas -pf.com":
    "The evaluation of your file is subject to automated processing which may lead to a refusal of your subscription request. You have the right to obtain human intervention, to express your point of view and to contest the decision by contacting us at the following address: Personal Finance Location - 62061 Arras - Cedex 9 or by email: serviceclientspflocation @ bnpparibas -pf.com",
  "You can object to receiving commercial prospecting by telephone by registering free of charge on the list of opposition to telephone canvassing on the website www.bloctel.gouv.fr or by post to - Société Opposetel, Service Bloctel, 6 rue Nicolas Siret 10000 Troyes. This registration prohibits a professional from canvassing you by telephone, unless this solicitation occurs in the context of the execution of a current contract and it relates to the subject of this contract.":
    "You can object to receiving commercial prospecting by telephone by registering free of charge on the list of opposition to telephone canvassing on the website www.bloctel.gouv.fr or by post to Opposetel company – Bloctel service, 6 rue Nicolas Siret, 10000 Troyes. This registration prohibits a professional from canvassing you by telephone, unless this solicitation occurs in the context of the execution of a current contract and it relates to the subject of this contract.",
  "You have the option to opt out of receiving commercial solicitations by phone by registering for free on the telephone solicitation opposition list available on the website www.bloctel.gouv.fr. This registration prohibits a professional from soliciting you by phone unless the solicitation is made as part of the execution of an ongoing contract and relates to the subject of that contract.":
    "You have the option to opt out of receiving commercial solicitations by phone by registering for free on the telephone solicitation opposition list available on the website www.bloctel.gouv.fr. This registration prohibits a professional from soliciting you by phone unless the solicitation is made as part of the execution of an ongoing contract and relates to the subject of that contract.",
  "Service contract managed by EVOLLIS, SAS with capital of 143 151,90 euros, whose head office is located 22-26 quai de Bacalan - 33300 Bordeaux, registered with the RCS of Bordeaux at n ° 530 612 571.":
    "Service contract managed by EVOLLIS, SAS with capital of 143 151,90 euros, whose head office is located 22-26 quai de Bacalan - 33300 Bordeaux, registered with the RCS of Bordeaux at n ° 530 612 571.",
  "Long-term rental contract, subject to acceptance of the file by the Lessor Personal Finance Long-term rental contract, subject to acceptance of the file by the Lessor Personal Finance Location and after expiration of the legal withdrawal period. Personal Finance Location - SASU with a capital of € 1,500,000 - Headquarters: 1 boulevard Haussmann - 75009 Paris - RCS Paris N °433 911 799.":
    "Long-term rental contract, subject to acceptance of the file by the Lessor Personal Finance Long-term rental contract, subject to acceptance of the file by the Lessor Personal Finance Location and after expiration of the legal withdrawal period. Personal Finance Location - SASU with a capital of € 1,500,000 - Headquarters: 1 boulevard Haussmann - 75009 Paris - RCS Paris N °433 911 799.",
  "Long-term rental agreement, subject to acceptance of the file by the Lessor, Personal Finance Location, SAS with a capital of €1,500,000, headquartered at 1 Boulevard Haussmann - 75009 Paris, RCS Paris No. 433 911 799. Associated with a service contract managed by EVOLLIS, SAS with a capital of €143,151.90, headquartered at 22-26 Quai de Bacalan – 33300 Bordeaux, RCS Bordeaux No. 530 612 571.":
    "Long-term rental agreement, subject to acceptance of the file by the Lessor, Personal Finance Location, SAS with a capital of €1,500,000, headquartered at 1 Boulevard Haussmann - 75009 Paris, RCS Paris No. 433 911 799. Associated with a service contract managed by EVOLLIS, SAS with a capital of €143,151.90, headquartered at 22-26 Quai de Bacalan – 33300 Bordeaux, RCS Bordeaux No. 530 612 571.",
  "Service's contract handled by Micromania SAS society with a capital of 32 230 000 € with head office at 955, Route des Lucioles, Valbonne 06560 ; Registered to the Registre du Commerce des sociétés de Grasse under the reference SIREN 418 096 392.":
    "Services contract managed by Micromania SAS with share capital of EUR 32,230,000, registered office at 955 Route des Lucioles, Valbonne 06560; registered with the Grasse Trade and Companies Register under SIREN no. 418 096 392.",
  "The information requested is for the management of your leasing request. Unless otherwise stated, they are mandatory and in the absence of a complete response, your request may be refused. If you choose not to let us know, we will not be able to process your request. They are intended for the Lessor, Personal Finance Location, data controller. Through it, you will be able to receive proposals from partners. For more information on the processing of your personal data by Personal Finance Location and on your rights (right of access, rectification, erasure, limitation of processing, data portability, right of opposition and right to organize the management of your data after your death) you can refer to the information notice on the use of personal data or contact us at the following address at Personal Finance Location - Customer Service - 62061 Cedex 9 - consommateurs.donneespersonnelles@cetelem.fr":
    "The information requested is for the management of your leasing request. Unless otherwise stated, they are mandatory and in the absence of a complete response, your request may be refused. If you choose not to let us know, we will not be able to process your request. They are intended for the Lessor, Personal Finance Location, data controller. Through it, you will be able to receive proposals from partners. For more information on the processing of your personal data by Personal Finance Location and on your rights (right of access, rectification, erasure, limitation of processing, data portability, right of opposition and right to organize the management of your data after your death) you can refer to the information notice on the use of personal data or contact us at the following address at Personal Finance Location - Customer Service - 62061 Cedex 9 - consommateurs.donneespersonnelles@cetelem.fr",
  "The information requested is for the management and evaluation of your Service Contract. Unless otherwise stated, they are mandatory and in the absence of a complete response, your request may be refused. If you choose not to let us know, we will not be able to process your request. They are intended for EVOLLIS, responsible for the processing. Through it, you will be able to receive proposals from partners. For more information on the processing of your personal data by EVOLLIS and on your rights (right of access, rectification, erasure, limitation of processing, data portability, right of opposition and right to organize the management of your data after your death) you can refer here to the use of your data or contact us at the following address EVOLLIS - Customer Service - 22 quai de Bacalan - 33300 Bordeaux or at protectiondonnees@evollis.com":
    "The information requested is for the management and evaluation of your Service Contract. Unless otherwise stated, they are mandatory and in the absence of a complete response, your request may be refused. If you choose not to let us know, we will not be able to process your request. They are intended for EVOLLIS, responsible for the processing. Through it, you will be able to receive proposals from partners. For more information on the processing of your personal data by EVOLLIS and on your rights (right of access, rectification, erasure, limitation of processing, data portability, right of opposition and right to organize the management of your data after your death) you can refer here to the use of your data or contact us at the following address EVOLLIS - Customer Service - 22 quai de Bacalan - 33300 Bordeaux or at protectiondonnees@evollis.com",
  "GARANTIE PRIVEE.COM, a simplified joint stock company with a capital of 60 000 euros, an insurance brokerage company registered in the Bordeaux Trade Register under number 521 279 737, and registered in the intermediaries' register under number ORIAS 10 055 738: Le Plaza II, 2 Place Ravezies, 33300 Bordeaux.":
    "GARANTIE PRIVEE.COM, a simplified joint stock company with a capital of 60,000 euros, an insurance brokerage company registered in the Bordeaux Trade Register under number 521 279 737, and registered in the intermediaries' register under number ORIAS 10 055 738: The Plaza II, 2 Place Ravezies, 33300 Bordeaux.",
  "L'EQUITE, a public limited company with a capital of 26 469 320 euros, registered in the Paris Trade and Companies Register under number B 572 084 697, a company governed by the French Insurance Code, a member of the GENERALI group, registered in the Italian Insurance Groups Register, domiciled at 2 rue Pillet-Will, 75009 Paris":
    "L'EQUITE, a public limited company with a capital of 26 469 320 euros, registered in the Paris Trade and Companies Register under number B 572 084 697, a company governed by the French Insurance Code, a member of the GENERALI group, registered in the Italian Insurance Groups Register, domiciled at 2 rue Pillet-Will, 75009 Paris",
  "Service contract managed by EVOLLIS - SAS with capital of € 1,277,010 - Headquarters: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571 - Intra-community VAT number: FR 195 306 125 71 - ORIAS number: 13003909.":
    "Service contract managed by EVOLLIS - SAS with capital of € 1,277,010 - Headquarters: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571 - Intra-community VAT number: FR 195 306 125 71 - ORIAS number: 13003909.",
  "Service contract managed by EVOLLIS - SAS with capital of € 166 190,60 - Headquarters: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571. N°ADEME : FR320894 _03JPOV.":
    "Service contract managed by EVOLLIS - SAS with capital of € 166 190,60 - Headquarters: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571. N°ADEME : FR320894 _03JPOV.",
  "You also have, in accordance with article L 223-2 of the Consumer Code, a right to register on the list of opposition to canvassing available on the website www.bloctel.gouv.fr. This registration prohibits a professional from canvassing by telephone, except in the case of pre-existing contractual relationships.":
    "You also have, in accordance with article L 223-2 of the Consumer Code, a right to register on the list of opposition to canvassing available on the website www.bloctel.gouv.fr. This registration prohibits a professional from canvassing by telephone, except in the case of pre-existing contractual relationships.",
  "Unless otherwise stated, the informations asked are mandatory. Collected data will be used by Personal Finance Location, data controller, in order to make your rent request succeed. They allow us to propose you adapted offers, and satisfy our legal obligations. If you need more information about data's treatment, and to exercise your rights : access right, rectification right, erasement right, treatment's limitation right, data portability, opposition right ( including the use of your personal data for prospecting purposes ) and the right to organize the management of your data after your death, please contact us at Personal Finance Location – Service Clients – 62061 ARRAS Cedex 9 - consommateurs.donneespersonnelles@cetelem.fr .":
    "Unless otherwise stated, the informations asked are mandatory. Collected data will be used by Personal Finance Location, data controller, in order to make your rent request succeed. They allow us to propose you adapted offers, and satisfy our legal obligations. If you need more information about data's treatment, and to exercise your rights : access right, rectification right, erasement right, treatment's limitation right, data portability, opposition right ( including the use of your personal data for prospecting purposes ) and the right to organize the management of your data after your death, please contact us at Personal Finance Location – Service Clients – 62061 ARRAS Cedex 9 - consommateurs.donneespersonnelles@cetelem.fr .",
  "Unless otherwise indicated, the information requested is mandatory. The data collected is intended for Personal Finance Location, the data controller, and is used to manage your rental request, to enable us to provide you with suitable offers, as well as to meet our legal and regulatory obligations. In the absence of a complete response, the long-term rental request cannot be processed, and the request will be rejected.":
    "Unless otherwise indicated, the information requested is mandatory. The data collected is intended for Personal Finance Location, the data controller, and is used to manage your rental request, to enable us to provide you with suitable offers, as well as to meet our legal and regulatory obligations. In the absence of a complete response, the long-term rental request cannot be processed, and the request will be rejected.",
  "You can object to receiving commercial prospecting by telephone by registering for free on the list of opposition to telephone canvassing on the website www.bloctel.gouv.fr or by post to - Société Opposetel, Service Bloctel, 6 rue Nicolas Siret 10000 Troyes. This registration prohibits a professional from canvassing you by telephone, unless this solicitation occurs in the context of the execution of a current contract and it has a connection with the subject of this contract.":
    "You can object to receiving commercial prospecting by telephone by registering for free on the list of opposition to telephone canvassing on the website www.bloctel.gouv.fr or by post to Opposetel company – Bloctel service, 6 rue Nicolas Siret, 10000 Troyes. This registration prohibits a professional from canvassing you by telephone, unless this solicitation occurs in the context of the execution of a current contract and it has a connection with the subject of this contract.",
  "Unless otherwise indicated, the information requested is mandatory. The data collected is intended for Personal Finance Location, data controller, and is used to manage your rental request, to enable us to provide you with suitable offers, as well as to meet our legal and regulatory obligations. For more information on the processing of your personal data and to exercise your rights: right of access, rectification, erasure, limitation of processing, data portability, right of opposition (including the use of your personal data for prospecting purposes) and the right to organize the management of your data after your death, you can contact us at the following address: Personal Finance Location - Service Clients - 62061 ARRAS Cedex 9 - consumers.donneespersonnelles@cetelem.fr.":
    "Unless otherwise indicated, the information requested is mandatory. The data collected is intended for Personal Finance Location, data controller, and is used to manage your rental request, to enable us to provide you with suitable offers, as well as to meet our legal and regulatory obligations. For more information on the processing of your personal data and to exercise your rights: right of access, rectification, erasure, limitation of processing, data portability, right of opposition (including the use of your personal data for prospecting purposes) and the right to organize the management of your data after your death, you can contact us at the following address: Personal Finance Location - Service Clients - 62061 ARRAS Cedex 9 - consumers.donneespersonnelles@cetelem.fr.",
  "For more information on the processing of your personal data and to exercise your rights: right of access, rectification, erasure, limitation of processing, data portability, right to object (including the use of your personal data for marketing purposes), and the right to organize the management of your data after your death, you can refer to the Personal Data Protection notice included in your rental agreement or contact us at the following address: Personal Finance Location – Consumer Service – 62061 Arras Cedex 9 or by email at consommateur.location.donneespersonnelles@cetelem.fr":
    "For more information on the processing of your personal data and to exercise your rights: right of access, rectification, erasure, limitation of processing, data portability, right to object (including the use of your personal data for marketing purposes), and the right to organize the management of your data after your death, you can refer to the Personal Data Protection notice included in your rental agreement or contact us at the following address: Personal Finance Location – Consumer Service – 62061 Arras Cedex 9 or by email at consommateur.location.donneespersonnelles@cetelem.fr",
  "The evaluation of your file is subject to automated processing, which may result in the refusal of your subscription request. You have the right to obtain human intervention, to express your point of view and to contest the decision by contacting us at the following address: Personal Finance Location - 62061 Arras - Cedex 9 or by email: serviceclientspflocation @ bnpparibas -pf.com":
    "The evaluation of your file is subject to automated processing, which may result in the refusal of your subscription request. You have the right to obtain human intervention, to express your point of view and to contest the decision by contacting us at the following address: Personal Finance Location - 62061 Arras - Cedex 9 or by email: serviceclientspflocation @ bnpparibas -pf.com",
  "The evaluation of your file is subject to automated processing, which may result in the refusal of your subscription request. You have the right to obtain human intervention, to express your point of view and to contest the decision by contacting us at the following address: Personal Finance Location - 62061 Arras - Cedex 9 or by email: consommateur.location.donneespersonnelles@cetelem.fr":
    "The evaluation of your file is subject to automated processing, which may result in the refusal of your subscription request. You have the right to obtain human intervention, to express your point of view and to contest the decision by contacting us at the following address: Personal Finance Location - 62061 Arras - Cedex 9 or by email: consommateur.location.donneespersonnelles@cetelem.fr",
  "Long-term rental contract, subject to acceptance of the file by the Hirer, Personal Finance Location, a simplified joint stock company with a capital of €1,500,000, Head Office: 1 boulevard Haussmann - 75009 Paris RCS Paris N° 433 911 799.":
    "Long-term rental contract, subject to acceptance of the file by the Hirer, Personal Finance Location, a simplified joint stock company with a capital of €1,500,000, Head Office: 1 boulevard Haussmann - 75009 Paris RCS Paris N° 433 911 799.",
  "You have a withdrawal period of 14 days for a remote rental application from the conclusion of the contract.":
    "You have a withdrawal period of 14 days for a remote rental application from the conclusion of the contract.",
  "You have a 14-day withdrawal period starting from the conclusion of the contract for a remote rental request.":
    "You have a 14-day withdrawal period starting from the conclusion of the contract for a remote rental request.",
  "It is possible to oppose to receive commercial prospecting by telephone by registering free of charge on the opposition list to telephone canvassing on the website or by mail to - Société Opposetel, Service Bloctel, 6 rue Nicolas Siret 10000 Troyes. This registration prohibits a professional from canvassing you by telephone, unless this canvassing is part of the execution of a current contract and is related to the purpose of this contract.":
    "It is possible to oppose to receive commercial prospecting by telephone by registering free of charge on the opposition list to telephone canvassing on the website or by mail to Opposetel company – Bloctel service, 6 rue Nicolas Siret, 10000 Troyes. This registration prohibits a professional from canvassing you by telephone, unless this canvassing is part of the execution of a current contract and is related to the purpose of this contract.",
  "Besoin d’aide ?": "Need help?",
  "Pour consulter les Mentions Légales, les Protections des données et la Politique de gestion des cookies, veuillez cliquer ici":
    "To view the legal notice, data protection information and the cookies policy, please click here",
  default_location_contract:
    "Long-term rental contract, subject to approval of the application by the lessor, Personal Finance Location, a simplified joint stock company with share capital of {shareCapitalFinancer} €, registered office: 1 boulevard Haussmann - 75009 Paris, Paris Trade and Companies Register no. 433 911 799.",
  conforama_location_contract:
    "Long-term rental contract with a services pack, subject to approval of the application by the lessor, Personal Finance Location, a simplified joint stock company with share capital of {shareCapitalFinancer} €, registered office: 1 boulevard Haussmann - 75009 Paris, Paris Trade and Companies Register no. 433 911 799.",
  default_withdrawal_paragraph:
    "You have a 14-day withdrawal period for a remote rental application from conclusion of the contract.",
  conforama_withdrawal_paragraph:
    "You have a 14-day withdrawal period for a rental application from conclusion of the contract.",
  conforama_withdrawal_paragraph_2: "You have a 14-day withdrawal period from conclusion of the contract.",
  default_personnal_data: {
    elementHtml: () => (
      <React.Fragment>
        {" "}
        <p>
          <small>
            Unless otherwise stated, the information requested is mandatory. The data collected is intended for Personal
            Finance Location, the data controller, and is used to manage your rental request, to enable us to offer you
            suitable products, and to meet our legal and regulatory obligations. For more information on the processing
            of your personal data and to exercise your rights (access, rectification, erasure, restriction of
            processing, data portability, objection—including to the use of your data for marketing purposes—and the
            right to organise the handling of your data after your death), please refer to the{" "}
            <u>Personal Data Protection notice</u> in your rental agreement or contact us at: Personal Finance Location
            – Consumer Services – 62061 Arras Cedex 9, or by email:{" "}
            <a href="mailto:consommateur.location.donneespersonnelles@cetelem.fr">
              consommateur.location.donneespersonnelles@cetelem.fr
            </a>
          </small>
        </p>{" "}
      </React.Fragment>
    )
  },
  conforama_personnal_data: {
    elementHtml: () => (
      <React.Fragment>
        {" "}
        <p>
          <small>
            Unless otherwise stated, the information requested is mandatory. The data collected is intended for Personal
            Finance Location, the data controller, and is used to manage your rental request, to enable us to offer you
            suitable products, and to meet our legal and regulatory obligations. For more information on the processing
            of your personal data and to exercise your rights (access, rectification, erasure, restriction of
            processing, data portability, objection—including to the use of your data for marketing purposes—and the
            right to organise the handling of your data after your death), please refer to the{" "}
            <u>Personal Data Protection notice</u> in your rental agreement or contact us at: Personal Finance Location
            – Consumer Services – 62061 Arras Cedex 9, or by email:{" "}
            <a href="mailto:consommateur.location.donneespersonnelles@cetelem.fr">
              consommateur.location.donneespersonnelles@cetelem.fr
            </a>
          </small>
        </p>{" "}
      </React.Fragment>
    )
  },
  default_black_list: {
    elementHtml: () => (
      <React.Fragment>
        {" "}
        <p>
          <small>
            You may object to receiving telephone marketing by registering free of charge on the telephone canvassing
            opposition list on the <a href="https://www.bloctel.gouv.fr/">Bloctel</a> website. This registration
            prohibits professionals from contacting you by telephone unless the call is made in the context of
            performing an existing contract and relates to the subject matter of that contract.
          </small>
        </p>{" "}
      </React.Fragment>
    )
  },
  conforama_black_list: {
    elementHtml: () => (
      <React.Fragment>
        {" "}
        <p>
          <small>
            You may object to receiving telephone marketing by registering free of charge on the telephone canvassing
            opposition list at <a href="https://www.bloctel.gouv.fr/">www.bloctel.gouv.fr</a>. This registration
            prohibits professionals from contacting you by telephone unless the call is made in the context of
            performing an existing contract and relates to the subject matter of that contract.
          </small>
        </p>{" "}
      </React.Fragment>
    )
  },
  micromania_web_service_contract:
    "Services contract managed by Micromania SAS with share capital of €32,230,000, registered office at 955 Route des Lucioles, Valbonne 06560; registered with the Grasse Trade and Companies Register under SIREN no. 418 096 392.",
  conforama_service_contract: {
    elementHtml: ({ shareCapitalFinancer, shareCapitalGroup }) => (
      <React.Fragment>
        <p>
          <small>
            For long-term rental of a TV: services contract managed by Personal Finance Location, a simplified joint
            stock company with share capital of {shareCapitalFinancer} €, registered office: 1 Boulevard Haussmann,
            75009 Paris, RCS Paris no. 433 911 799.
          </small>
        </p>
        <p>
          <small>
            For long-term rental of a chair: services contract managed by Conforama France, SA with share capital of{" "}
            {shareCapitalGroup} euros, registered office at 80 Boulevard du Mandinet, Lognes, 77432 Marne-la-Vallée
            Cedex, registered with the Meaux Trade and Companies Register under SIREN no. 414 819 409
          </small>
        </p>
      </React.Fragment>
    )
  },
  "Internal error": "Internal error",
  "The server was unable to process your request.": "The server was unable to process your request.",
  "The server has encountered an error, and couldn't treat your request.":
    "The server has encountered an error, and couldn't treat your request.",
  "Page not found": "Page not found",
  "The page you're asking for doesn't exist or had been deleted":
    "The page you're asking for doesn't exist or had been deleted",
  "Service unavailable": "Service unavailable",
  "Service is unavailable, please come back later.": "Service is unavailable, please come back later.",
  "Pending request": "Pending request",
  "You have 2 days to finalize your request by uploading your supporting documents.":
    "You have 2 days to finalize your request by uploading your supporting documents.",
  "We will send you an email allowing you to finalize your file later.":
    "We will send you an email allowing you to finalize your file later.",
  "Not a valid IBAN": "Invalid IBAN",
  french_iban: "Please enter a French IBAN",
  "Not a valid BIC": "Invalid BIC",
  Required: "Required field",
  "Enter data": "Enter data",
  "Invalid data": "Invalid data",
  "Date is not valid": "Date is not valid",
  Maximum: "Maximum",
  characters: "characters",
  "minimum characters": "characters minimum",
  "maximum characters": "characters maximum",
  "Unauthorized characters": "Unauthorized characters",
  "Phone number must start with 06 or 07 and contain 10 numbers":
    "The phone number must start with 06 or 07 and contain 10 digits",
  "Invalid postal code": "Invalid postal code",
  "Invalid phone number": "Invalid number",
  "Minimum age must be > 18 years old": "Minimum age must be > 18 years",
  "Maximum age must be < 110 years old": "Maximum age must be < 110 years",
  "Must be positive": "Must be positive",
  "number of children must be contains between 0 and 10": "The number of children must be between 0 and 10",
  "birthDate is not valid": "Invalid date of birth",
  "employmentDate cannot be before birthDate": "employmentDate cannot be before birthDate",
  "Year seniority bank cannot be before birth date": "Bank seniority date cannot be before date of birth",
  "difference between employment date and birth date must be at least 16 years":
    "The difference between employment date and date of birth must be at least 16 years",
  "difference between bank seniority date and birth date must be at least 16 years":
    "The difference between bank seniority date and date of birth must be at least 16 years",
  "employmentDate cannot be in future": "employmentDate cannot be in future",
  "Must be a whole number": "Must be a whole number",
  "Must be a number": "Must be a number",
  "Email invalid": "Invalid email address",
  bpls_invalid_email: "Invalid email",
  bpls_different_email: {
    propsValues: (props) => {
      const { paragraph } = props
      return <>{paragraph}</>
    }
  },
  bpls_different_phone: {
    propsValues: (props) => {
      const { paragraph } = props
      return <>{paragraph}</>
    }
  },
  "Wrong bank account owner format": "The name must contain at least one letter",
  "Please assert you're the real card owner": "Tick to confirm you are the owner of this payment card",
  "Not a valid MM value": "Month must be in MM format",
  "Not a valid YYYY date": "Year must be in YYYY format",
  "Not a valid date": "Invalid date",
  "Can't be before current year": "Can't be before current year",
  "Must be composed of 3 digits": "Must be 3 digits",
  "Must be composed of 12-19 digits": "Must be 12–19 digits",
  "Not a valid YYYY-MM-DD date": "Enter a date in DD/MM/YYYY format",
  "Residence date cannot be before birth date": "Residence date cannot be before date of birth",
  "This date cannot be in future": "This date cannot be in the future",
  "Employment date cannot be before birth date": "Employment date cannot be before date of birth",
  "Employment date cannot be in future": "Employment date cannot be in the future",
  "Please pick a correct value": "Please choose a valid value",
  validator_invalidNetMounthlyIncomeFormat: "Invalid net monthly income format.",
  validator_endContractDateInFuture: "The contract end date cannot be in the past.",
  "Your request is already finalized": "Your request is already finalized",
  "You will receive a final response within 24 hours.": "You will receive a final response within 24 hours.",
  "Thank you for your request.": "Thank you for your request.",
  "Your request has already been validated": "Your request has already been validated",
  "The information you have entered can no longer be changed.":
    "The information you have entered can no longer be changed.",
  "Please click on the button below to finalize your order.":
    "Please click on the button below to finalize your order.",
  "Finalize your order": "Finalize your order",
  "Operation failed": "Operation failed",
  "Your order is canceled. The amount of the upfront will not be deducted from you.":
    "Your order is canceled. The amount of the upfront will not be deducted from you.",
  "Your order has been cancelled.": "Your order has been cancelled.",
  please_study_other_payment_means: "We invite you to review the other payment options offered for the product.",
  "Request denied": "Request denied",
  "We regret to inform you that we cannot give a favorable response to your request.":
    "We regret to inform you that we cannot give a favorable response to your request.",
  Maintenance: "Maintenance",
  "The app is temporarily unavailable.": "The app is temporarily unavailable.",
  "Please come back later.": "Please come back later.",
  "Contract start date": "Contract start date",
  "Contract end date": "Contract end date",
  "Contract renewal date": "Contract renewal date",
  "New Order": "New order",
  "Renew Order": "Renew my contract",
  "Bad credentials": "Bad credentials",
  username: "Username",
  password: "Password",
  connect: "Log in",
  "need help": "need help",
  "login page need help tooltip": "login page need help tooltip",
  "User account is locked": "User account is locked",
  password_expired: "Password expired",
  old_password: "Old password",
  new_password: "New password",
  verify_new_password: "Confirm new password",
  change_password: "Update your password",
  confirmation_password_matches_new_password: "The new password is confirmed",
  old_password_matches_current_password: "Your current password does not match the one entered!",
  TOUS: "All",
  WAIT_SIGNATURE: "Awaiting signature",
  WAITING_DOCUMENTS: "Awaiting documents",
  REJECTED: "Rejected",
  PJ_UPLOADES: "Supporting documents uploaded",
  ACCEPTED_AWAITING_FUNDING: "Accepted — pending financing",
  NOT_FINALIZED: "Not finalised",
  A_TRAITER_OCTROI: "To be processed — grant",
  REFUSED_AFTER_DOCUMENT_ANALYSIS: "Refused after document review",
  DEFAULT: "DEFAULT n/a",
  bpls_footer: {
    propsValues: (props) => {
      const { legalMention, privacyPolicy, cookiesPolicy } = props
      return (
        <>
          © BNP Paribas Leasing Solutions {legalMention} - {privacyPolicy} - {cookiesPolicy}
        </>
      )
    }
  },
  legalMention: "Legal notices",
  legalMentionTitle: "Link to BNP Paribas Leasing Solutions legal notices",
  privacyPolicy: "Privacy policy",
  privacyPolicyTitle: "Link to BNP Paribas Leasing Solutions privacy policy",
  cookiesPolicy: "Cookie policy",
  cookiesPolicyTitle: "Link to BNP Paribas Leasing Solutions cookie policy",
  home_button_new: "New simulation",
  home_button_new_description: "Start a simulation",
  home_button_takeover: "My Nini simulations",
  home_button_takeover_description: "Resume a simulation",
  home_button_renewal: "My renewals",
  home_button_renewal_description: "Renew an eligible contract",
  home_button_continue_order: "Case in progress",
  home_button_continue_order_description: "Resume an unfinished order",
  home_button_after_sales: "After-sales",
  home_button_after_sales_description: "Manage my contracts, access tools",
  resume_order_load_search: "Searching...",
  resume_order_success_search: "Search complete",
  resume_order_error_search: "Error while searching",
  resume_order_input_search_label: "Name or order no.",
  resume_order_fill_shipping_date_button_label: "Enter a delivery date",
  previous: "Previous",
  next: "Next",
  shop: "Store",
  search: "Search",
  save: "Save",
  identification_button_saveForLater: "Save and send the simulation to the customer",
  search_no_result: "No results",
  simulation_shop_block_title: "Store selection",
  simulation_shop_input_label: "Select a store",
  simulation_delivery_block_title: "Delivery method",
  simulation_delivery_input_label: "Select how the product will be made available",
  simulation_products_block_title: "Product selection",
  simulation_family_input_label: "Family",
  simulation_category_input_label: "Category",
  simulation_price_input_label: "Price incl. VAT",
  simulation_quantity_input_label: "Quantity",
  simulation_product_input_label: "Product",
  simulation_button_create_product: "+ Enter",
  simulation_brand_input_label: "Brand",
  simulation_description_input_label: "Description",
  simulation_button_add_product: "+ Add a product",
  simulation_promotion_block_title: "Promotion",
  simulation_promotion_input_label: "Promo code",
  simulation_promotion_button_label: "Apply",
  simulation_promotion_response_valid: {
    propsValues: (props) => {
      const { promotionCode } = props
      return `Your promo code “${promotionCode}” has been applied.`
    }
  },
  simulation_promotion_response_invalid: "Your promo code could not be applied.",
  simulation_button_reset: "Reset",
  simulation_button_update: "Refresh simulation",
  create_product_inprogress_toast: "Creating...",
  create_product_success_toast: "Product added",
  create_product_error_toast: "Error while creating the product",
  create_product_title: "Create a new product",
  one_lower_case_required: "At least one lowercase letter",
  one_upper_case_required: "At least one uppercase letter",
  one_number_required: "At least one digit or symbol",
  more_than_height_length: "At least 8 characters",
  different_password: "Password must differ from the current one",
  simulation_final_page_title: "Simulation saved",
  simulation_final_page_content: {
    propsValues: (props) => {
      const { simulationStorageTime } = props
      return (
        <>
          <p>Your simulation has been saved successfully.</p>
          <p>
            Your customer has received this simulation by email with a link allowing them to complete their rental
            application.
          </p>
          <p>Please note: this link is only valid for {simulationStorageTime} day(s).</p>
        </>
      )
    }
  },
  start_by_searching_for: "Start by running a search...",
  loading_orders: "Loading cases...",
  sort_by: "Sort by",
  newest: "Newest",
  oldest: "Oldest",
  filter_by: "Filter by",
  document_type: "Document type",
  "A emporter": "Takeaway",
  "A emporter différé": "Deferred in-store pickup",
  retail_patch_order_success_label: "Your number has been saved successfully.",
  change_identity_bloc_simplified_journey:
    "If you wish to change the data in “My identity”, please contact customer service at {adresse}",
  algoanBankModal_loadingAria: "Loading",
  algoanBankModal_loadingText: "Retrieving your bank accounts…",
  algoanBankModal_errorMessage: "An error occurred; please try again later.",
  algoanBankModal_retry: "Retry",
  algoanBankModal_titleSingle: "The bank account from which your monthly payments will be collected",
  algoanBankModal_titleMultiple: "Choose the bank account from which you want your monthly payments to be collected",
  algoanBankModal_continue: "Continue",
  algoanBankModal_noAccount: "We could not identify a bank account in your name.",
  algoanBankModal_noAccountAdvice: "Please start again and use a bank account that you own.",
  algoanBankModal_CURRENCY_NOT_SUPPORTED_title: "Currency not supported",
  algoanBankModal_CURRENCY_NOT_SUPPORTED_message:
    "We cannot analyse your bank account because the account currency is not compatible with our service. Please use an account in euros.",
  algoanBankModal_NO_CHECKING_ACCOUNT_title: "No current account detected",
  algoanBankModal_NO_CHECKING_ACCOUNT_message:
    "We did not detect a current account in your name. Please use a standard current account to continue.",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_title: "Unknown account type",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_message:
    "The bank account type detected is not compatible with our analysis. Please use a standard bank account.",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_title: "Non-holder client (power of attorney)",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_message:
    "The bank account used does not appear to be in your name. Please use an account of which you are the holder.",
  algoanBankModal_USAGE_NOT_SUPPORTED_title: "Business account",
  algoanBankModal_USAGE_NOT_SUPPORTED_message:
    "Business accounts are not accepted. Please use a personal bank account.",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_title: "Not enough transactions",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_message:
    "We do not have enough bank history to analyse your situation. Please use an account with recent transactions.",
  algoanBankModal_UNKNOWN_title: "Unidentified case",
  algoanBankModal_UNKNOWN_message: "An error occurred while analysing your bank account. Please try again later.",
  "2 claims maximum per insurance year. Ceiling 1500 € per insurance year.":
    "2 claims maximum per insurance year. Ceiling 1500 € per insurance year.",
  "A good internet connection": "A good internet connection",
  "A problem occurred during finalization. You will be redirected shortly.":
    "A problem occurred during finalization. You will be redirected shortly.",
  "Acepto el envío de comunicaciones comerciales sobre productos de terceras entidades con las que Banco Cetelem S.A.U. mantenga acuerdos comerciales, previo realizacíon de un perfilado de mis datos y consulta a sistemas externos de informacíon crediticia. Más información":
    {
      propsValues: () => {
        return <SamsungESOptin2 />
      }
    },
  "Acepto el envio de comunicaciones comerciales sobre productos financieros y de seguros de entidades del Grupo BNP Paribas en España previa realizacíon de un perfilado de mis datos y consulta a sistema externos de información crediticia. Más información":
    {
      propsValues: () => {
        return <SamsungESOptin1 />
      }
    },
  "Aplazame checkout status": "Aplazame checkout status",
  "APZ Netheos recovery after finalize error": "APZ Netheos recovery after finalize error",
  "APZ Netheos recovery missing token": "APZ Netheos recovery missing token",
  "Automatically verify your identity through Facematch, and then take a photo of your ID and yourself, the steps are specified throughout the process.":
    "Automatically verify your identity through Facematch, and then take a photo of your ID and yourself, the steps are specified throughout the process.",
  "Bank card": "Bank card",
  "Being in a well-lit place": "Being in a well-lit place",
  "BIC or SWIFT": "BIC or SWIFT",
  "By clicking you confirm that you have read the privacy policy relating to your rental practice": {
    elementHtml: () => (
      <React.Fragment>
        {" "}
        By clicking you confirm that you have read the{" "}
        <a href="https://static-it.evollis.com/privacy_it.pdf" target="_blank" rel="noopener noreferrer" alt="">
          privacy notice
        </a>{" "}
        relating to your rental application
      </React.Fragment>
    )
  },
  "By continuing, you confirm that you have read the": "By continuing, you confirm that you have read the",
  "by credit card will only be effective after signing your rental contract and downloading your supporting documents.If your rental request is subsequently refused by the Lessor following its study, then this amount will be immediately refunded.":
    "by credit card will only be effective after signing your rental contract and downloading your supporting documents.If your rental request is subsequently refused by the Lessor following its study, then this amount will be immediately refunded.",
  Cancel: "Cancel",
  Cap: "Cap",
  "Choisissez la durée qui vous convient le mieux, votre loyer s'ajustera en fonction de la durée choisie.":
    "Choose the duration that suits you best; your rent will adjust according to the chosen duration.",
  citizenshipExtended: "Nationality",
  CitizenshipIT: "Citizenship",
  "Cliccando confermi la presa visione dell'informativa privacy relativa alla tua pratica di noleggio": {
    propsValues: (props) => {
      let hrefToDoc = `https://static-it.evollis.com/privacy_it.pdf`
      return (
        <React.Fragment>
          By clicking you confirm that you have read the{" "}
          <a href={hrefToDoc} target="_blank" rel="noopener noreferrer" alt="">
            privacy notice
          </a>{" "}
          relating to your rental application
        </React.Fragment>
      )
    }
  },
  "Communication or transfer of data to third parties for the purposes of commercial communication with traditional and automated methods, of their products and services.":
    "Communication or transfer of data to third parties for the purposes of commercial communication with traditional and automated methods, of their products and services.",
  "Company city": "Company city",
  "Company province": "Company province",
  "Confirmo haber leído y aceptado las Condiciones Generales de Alquiler y la Política de Privacidad. También autorizo el cargo del primer pago único relacionado con el contrato de alquiler en mi cuenta bancaria, así como el cargo mensual del alquiler.":
    {
      elementHtml: () => (
        <React.Fragment>
          {" "}
          I confirm that I have read and accepted the
          <a
            href="https://static-seib.evollis.com/pdf/contract_es.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            General Rental Terms and Conditions{" "}
          </a>
          and the{" "}
          <a href="https://static-seib.evollis.com/pdf/privacy_es.pdf" target="_blank" rel="noopener noreferrer" alt="">
            {" "}
            Privacy Policy.
          </a>{" "}
          I also authorize the charge for the first one-off payment related to the rental agreement on my bank account,
          as well as the monthly rent charge.
        </React.Fragment>
      )
    },
  "Confirmo que li e aceito as Condições Gerais de Locação e a Política de Privacidade. Também autorizo o débito do primeiro pagamento único relativo ao contrato de locação na minha conta bancária, bem comme o débito mensal do aluguel.":
    {
      elementHtml: () => (
        <React.Fragment>
          {" "}
          I confirm that I have read and accepted the
          <a
            href="https://static-seib.evollis.com/pdf/contract_pt.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            General Rental Terms and Conditions{" "}
          </a>
          and the{" "}
          <a href="https://static-seib.evollis.com/pdf/privacy_pt.pdf" target="_blank" rel="noopener noreferrer" alt="">
            {" "}
            Privacy Policy.
          </a>{" "}
          I also authorize the debit of the first one-off payment related to the rental agreement from my bank account,
          as well as the monthly rent debit.
        </React.Fragment>
      )
    },
  Congratulations: "Congratulations",
  "Contract type": "Contract type",
  "country Of Activity": "country Of Activity",
  "Country of residence": "Country of residence",
  "Date of issue": "Date of issue",
  "De eerste betaling zal middels iDEAL door onze service provider Adyen worden uitgevoerd. Adyen B.V. is een besloten vennootschap met beperkte aansprakelijkheid. Adyen B.V. staat geregistreerd bij de Kamer van Koophandel onder nummer 34259528 en is gevestigd aan de Simon Carmiggeltstraat 6-50, 1011 DJ Amsterdam, Nederland.":
    "The first payment will be processed via iDEAL by our service provider Adyen. Adyen B.V. is a private limited liability company registered with the Chamber of Commerce under number 34259528, with its registered office at Simon Carmiggeltstraat 6-50, 1011 DJ Amsterdam, Netherlands.",
  "detail Of Income": "detail Of Income",
  Duration: "Duration",
  "Employment start date": "Employment start date",
  "En commande": "En commande",
  endContractDate: "Contract end date",
  "Evaluation purposes for the rental, with transmission of any data from Findomestic Banca S.p.A.":
    "Evaluation purposes for the rental, with transmission of any data from Findomestic Banca S.p.A.",
  "Expiry residence permit date": "Expiry residence permit date",
  FirstParagraphSmallBusiness:
    "Select this option only if you are a self-employed professional with a VAT number in order to access the tax benefits related to advance rent invoices and the monthly rent.",
  "for simulation": "for simulation",
  "Hierbij geef ik mijn uitdrukkelijke toestemming voor de verwerking van mijn persoonsgegevens voor de doeleinden als gespecificeerd in de Privacy Policy":
    {
      elementHtml: () => (
        <React.Fragment>
          {" "}
          I hereby give my explicit consent to the processing of my personal data for the purposes specified in the
          <a
            href="https://static-samsung-nl.evollis.com/pdf/privacy_nl.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            Privacy Policy
          </a>
          .
        </React.Fragment>
      )
    },
  home_button_penalty_simulation: "Penalty simulator",
  "I agree to receive electronic commercial offers from Evollis.":
    "I agree to receive electronic commercial offers from Evollis.",
  "I agree to receive electronically commercial offers from companies in the BNP Paribas Personal Finance group.":
    "I agree to receive electronically commercial offers from companies in the BNP Paribas Personal Finance group.",
  "I agree to receive Evollis' commercial offers electronically, as well as digital communications related to the performance of Samsung Care+ (if I have subscribed to it).":
    "I agree to receive Evollis' commercial offers electronically, as well as digital communications related to the performance of Samsung Care+ (if I have subscribed to it).",
  "I agree to receive Evollis’ commercial offers electronically, as well as digital communications related to the performance of Samsung Care+ (if I have subscribed to it).":
    "I agree to receive Evollis’ commercial offers electronically, as well as digital communications related to the performance of Samsung Care+ (if I have subscribed to it).",
  "I confirm that I have read and accepted the General Rental Terms and Conditions, the Privacy Policy, and, where applicable, the Samsung Care+ Terms of Use and the Insurance Product Information Document (IPID). I also authorize the debit of the initial one-time payment related to the rental agreement from my bank account, as well as the monthly debit of the insurance premiums together with the rent if I have subscribed to Samsung Care+ protection.":
    {
      elementHtml: () => (
        <React.Fragment>
          {" "}
          I confirm that I have read and accepted the
          <a
            href="https://static-samsung-be.evollis.com/pdf/contract_be.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            General Rental Terms and Conditions,{" "}
          </a>
          the{" "}
          <a
            href="https://static-samsung-be.evollis.com/pdf/privacy_be.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            Privacy Policy
          </a>{" "}
          and, where applicable, the Samsung Care+ Terms of Use and the insurance product information document (IPID). I
          also authorize the debit of the initial one-off payment for the rental agreement from my bank account, as well
          as the monthly debit of insurance premiums together with my rent if I have subscribed to Samsung Care+
          protection.
        </React.Fragment>
      )
    },
  "I hereby declare that I have read the terms and conditions and the privacy policy and agree with their content": {
    elementHtml: () => (
      <React.Fragment>
        {" "}
        I hereby declare that I have read the
        <a
          href="https://static-samsung-be.evollis.com/pdf/contract_be.pdf"
          target="_blank"
          rel="noopener noreferrer"
          alt=""
        >
          {" "}
          rental terms of use{" "}
        </a>
        and those of Samsung Care+, as well as the insurance information document (IPID) where I have subscribed to
        Samsung Care+, and the{" "}
        <a
          href="https://static-samsung-be.evollis.com/pdf/privacy_be.pdf"
          target="_blank"
          rel="noopener noreferrer"
          alt=""
        >
          {" "}
          Privacy Policy
        </a>{" "}
        and accept their content. I also authorize the debit of the first one-off payment for the rental agreement from
        my bank account, and to be charged insurance premiums monthly together with my rent, if I have opted for
        protection with Samsung Care+.
      </React.Fragment>
    )
  },
  "I hereby give my explicit consent to the processing of my personal data for the purposes specified in the privacy policy":
    {
      elementHtml: () => (
        <React.Fragment>
          {" "}
          I hereby give my explicit consent to the processing of my personal data for the purposes specified in the
          <a
            href="https://static-samsung-be.evollis.com/pdf/privacy_be.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            Privacy Policy
          </a>
          .
        </React.Fragment>
      )
    },
  "I oppose the receipt of commercial offers by mail or telephone from Evollis.":
    "I oppose the receipt of commercial offers by mail or telephone from Evollis.",
  "I oppose the receipt of commercial offers by post or telephone from BNP Paribas Personal Finance group companies.":
    "I oppose the receipt of commercial offers by post or telephone from BNP Paribas Personal Finance group companies.",
  "IBAN must have 24 characters": "IBAN must have 24 characters",
  "Identification expiration date": "Identification expiration date",
  "Identity document / driving license number: invalid": "Identity document / driving license number: invalid",
  "Identity document issue date: Invalid date / DD / MM / YYYY format":
    "Identity document issue date: Invalid date / DD / MM / YYYY format",
  "Identity document number": "Identity document number",
  "Identity document type": "Identity document type",
  "Ik bevestig dat ik kennis heb genomen van en akkoord ga met de Algemene Huurvoorwaarden, het Privacybeleid en, in voorkomend geval, de Algemene Voorwaarden van Samsung Care+ en het informatiedocument over de verzekering (IPID). Ik machtig eveneens de afschrijving van de eenmalige eerste betaling met betrekking tot het huurcontract van mijn bankrekening, evenals de maandelijkse afschrijving van de verzekeringspremies samen met de huur indien ik heb gekozen voor de Samsung Care+ bescherming.":
    {
      elementHtml: () => (
        <React.Fragment>
          {" "}
          I confirm that I have read and agree to the
          <a
            href="https://static-samsung-nl.evollis.com/pdf/contract_nl.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            General Rental Terms and Conditions,{" "}
          </a>
          the{" "}
          <a
            href="https://static-samsung-nl.evollis.com/pdf/privacy_nl.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            Privacy Policy
          </a>{" "}
          and, where applicable, the Samsung Care+ Terms and Conditions and the insurance product information document
          (IPID). I also authorize the debit of the one-off first payment for the rental agreement from my bank account,
          as well as the monthly debit of insurance premiums together with my rent if I have chosen Samsung Care+
          protection.
        </React.Fragment>
      )
    },
  "Ik stem ermee in om langs elektronische weg commerciële aanbiedingen van Evollis te ontvangen ":
    "I agree to receive commercial offers from Evollis electronically and digital communications for the performance of Samsung Care+.",
  "Ik stem ermee in om per post of telefoon commerciële aanbiedingen van Evollis te ontvangen":
    "I object to receiving commercial offers from Evollis by post or telephone.",
  "Ik verklaar hierbij dat ik de Algemene voorwaarden en de Privacy Policy heb gelezen en dat ik instem met de inhoud ervan. Ik geef daarnaast toestemming om de eerste éénmalige betaling voor het Private Lease Contract middels iDEAL van mijn bankrekening af te schrijven.":
    {
      elementHtml: () => (
        <React.Fragment>
          {" "}
          I hereby declare that I have read the
          <a
            href=" https://static-samsung-nl.evollis.com/pdf/contract_nl.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            General Terms and Conditions{" "}
          </a>
          of Evollis and, if I have chosen Samsung Care+, the Samsung Care+ terms, as well as the insurance information
          document (IPID) and the{" "}
          <a
            href=" https://static-samsung-nl.evollis.com/pdf/privacy_nl.pdf"
            target="_blank"
            rel="noopener noreferrer"
            alt=""
          >
            {" "}
            Privacy Policy
          </a>
          , and I agree to their content. I also authorize the first one-off payment for the rental agreement to be
          debited via iDEAL from my bank account, and the insurance premium to be debited monthly together with my rent,
          if I have chosen protection with Samsung Care+.{" "}
        </React.Fragment>
      )
    },
  import_document: "Import a document",
  "income Origin": "income Origin",
  "Indefinite period": "Indefinite period",
  "Invalid date in past": "Invalid date in past",
  "Invalid format": "Invalid format",
  "Invalid format fixe phone": "Invalid format fixe phone",
  "Invalid phone number fnac": "Invalid phone number fnac",
  "Invalid VAT Number": "Invalid VAT Number",
  INVOICE: "Invoice",
  Landline: "Landline (optional)",
  "line Of Business": "line Of Business",
  "Long-term rental contract, subject to acceptance of the file by the Lessor, Evollis, a Simplified Joint Stock Company under French law, with a capital of € {shareCapitalFinancer} , having its head office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.":
    "Long-term rental contract, subject to acceptance of the file by the Lessor, Evollis, a Simplified Joint Stock Company under French law, with a capital of € {shareCapitalFinancer} , having its head office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.",
  Madame: "Ms",
  "Main exclusions": "Main exclusions",
  "Market research, commercial communication with automated methods, on own and third party products and services.":
    "Market research, commercial communication with automated methods, on own and third party products and services.",
  "Missing data for retry. Please reload or contact support.":
    "Missing data for retry. Please reload or contact support.",
  "MM/YYYY": "MM/YYYY",
  Monsieur: "Mr",
  "Monthly income: Invalid ": "Monthly income: Invalid ",
  "Montly amount to be paid": "Montly amount to be paid",
  "My identity documents": "My identity documents",
  "My orders": "My orders",
  "Nadat uw eerste betaling is ontvangen en uw aanvraag is ingediend, zal Evollis uw aanvraag beoordelen. Evollis zal u eventueel verzoeken om aanvullende informatie te verstrekken. Pas nadat Evollis uw aanvraag definitief heeft aanvaard, komt het Private Lease contract tot stand. Als mocht blijken dat u onverhoopt niet in aanmerking kunt komen voor Private Lease, dan krijgt u de eerste betaling weer teruggestort op uw rekening. Daarnaast heeft u uiteraard het recht om binnen 14 dagen nadat u uw aanvraag heeft ingediend, het contract kosteloos te beëindigen. In dat geval krijgt u de eerste betaling ook weer teruggestort op uw rekening.":
    "After your first payment is received and your application is submitted, Evollis will assess your application. Evollis may ask you to provide additional information. Only once Evollis has definitively accepted your application will the Private Lease contract take effect. If you are not eligible for Private Lease, the first payment will be refunded to your account. You also have the right to terminate the contract free of charge within 14 days of submitting your application; in that case the first payment will also be refunded.",
  no: "No",
  "№ contrato de renting": "Rental agreement no.",
  "Not a valid identity number": "Not a valid identity number",
  "Not a valid MM/YYYY date": "Not a valid MM/YYYY date",
  "Not a valid tax number": "Not a valid tax number",
  "Not a valid YYYY/MM/DD date": "Not a valid YYYY/MM/DD date",
  "Not valid document": "Not valid document",
  "Number of driving license": "Number of driving license",
  Offered: "Included",
  partitaIvaTooltipDescription: {
    propsValues: ({ description }) => {
      return description
    }
  },
  partitaIvaWarningdescription:
    "This field is not intended for corporations (SpA, Srl, etc.), partnerships or sole proprietorships in the Italian sense.",
  "Patente elettronica, if I follow the rule which starts with U and I do not choose the correct city Roma, when I confirm the page, put the message":
    "Patente elettronica, if I follow the rule which starts with U and I do not choose the correct city Roma, when I confirm the page, put the message",
  "penalties for contract": "penalties for contract",
  "penalty calculation": {
    elementHtml: () => (
      <React.Fragment>
        {" "}
        Click here to{" "}
        <a href="https://www.personalrenting.com/calcolo-penali " target="_blank" rel="noopener noreferrer" alt="">
          simulate contract penalties
        </a>
      </React.Fragment>
    )
  },
  "Permit, residence permit": "Permit, residence permit",
  "Photo of your ID": "Photo of your ID",
  "Place of issue": "Place of issue",
  "Please wait…": "Please wait…",
  "privacy policy": "privacy policy",
  Product: "Product",
  "professional Use": "professional Use",
  Province: "Province",
  remove_product: "Remove product",
  "Renewal product": "Renewal product",
  "Renewal request": "Renewal request",
  "Retry failed. Please try again.": "Retry failed. Please try again.",
  "Retry finalization": "Retry finalization",
  "Samsung APZ final page message": "Samsung APZ final page message",
  "samsung es legals 1": {
    elementHtml: () => (
      <React.Fragment>
        <p>
          <small>
            *By clicking validate I confirm that I have read and accept the{" "}
            <a
              href="https://static-cetelem-es.evollis.com/pdf/information_previa_sto.pdf"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            >
              {" "}
              pre-contract information for the Renting agreement{" "}
            </a>{" "}
            and{" "}
            <a
              href="https://static-cetelem-es.evollis.com/pdf/Cláusula_informativa_primera_capa_proceso_contratación_150622.pdf"
              target="_blank"
              rel="noopener noreferrer"
              alt=""
            >
              {" "}
              Banco Cetelem, S.A.U.’s data protection policy.{" "}
            </a>
          </small>
        </p>
      </React.Fragment>
    )
  },
  "samsung es legals 2": "samsung es legals 2",
  "samsung es legals 3": "samsung es legals 3",
  SAMSUNG_IT_PRIVACY_POLICY_AGREEMENT: {
    propsValues: (props) => {
      let hrefToDoc = `https://static-it.evollis.com/privacy_it.pdf`
      return (
        <React.Fragment>
          By clicking you confirm that you have read the{" "}
          <a href={hrefToDoc} target="_blank" rel="noopener noreferrer" alt="">
            privacy notice
          </a>{" "}
          relating to your rental application
        </React.Fragment>
      )
    }
  },
  "Service contract managed by EVOLLIS - SAS with capital of € {shareCapitalFinancer} - Headquarters: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571 - Intra-community VAT number: FR 195 306 125 71 - ORIAS number: 13003909.":
    "Service contract managed by EVOLLIS - SAS with capital of € {shareCapitalFinancer} - Headquarters: 22 Quai de Bacalan 33300 Bordeaux - RCS Bordeaux N ° 530 612 571 - Intra-community VAT number: FR 195 306 125 71 - ORIAS number: 13003909.",
  SmallBusiness: "Self-employed with VAT number",
  SmallBusinessDescription: {
    propsValues: (props) => {
      return props?.text
    }
  },
  "Summary of services included": "Summary of services included",
  "Summary of services included ": "Summary of services included ",
  "Tax number": "Tax number",
  "Temporary document": "Temporary document",
  "The accessories, and connectors of the device. Normal wear and tear of the device. Negligence, forgetting the device. Theft from the primary and secondary residence.":
    "The accessories, and connectors of the device. Normal wear and tear of the device. Negligence, forgetting the device. Theft from the primary and secondary residence.",
  "The purpose of the information requested from you is to manage and execute your lease. Unless otherwise agreed, the provision of the requested information is mandatory. If the information provided is not complete, your rental request may be rejected. If you choose not to provide information, we will not be able to process your request. Your information is only intended for Evollis as manager and executor of the lease. By providing your information, you may receive commercial offers from our partners. If you want more information about the processing of your personal data by Evollis and your rights in this regard (access, rectification, deletion, limitation of processing, data transfer, get it here. You can also contact us at our postal address: Evollis, Customer Service, 22 quai de Bacalan, 33300 Bordeaux, France or by e-mail: protectiondonnees@evollis.com":
    "The purpose of the information requested from you is to manage and execute your lease. Unless otherwise agreed, the provision of the requested information is mandatory. If the information provided is not complete, your rental request may be rejected. If you choose not to provide information, we will not be able to process your request. Your information is only intended for Evollis as manager and executor of the lease. By providing your information, you may receive commercial offers from our partners. If you want more information about the processing of your personal data by Evollis and your rights in this regard (access, rectification, deletion, limitation of processing, data transfer, get it here. You can also contact us at our postal address: Evollis, Customer Service, 22 quai de Bacalan, 33300 Bordeaux, France or by e-mail: protectiondonnees@evollis.com",
  "The server did not return a signature session. Please try again or contact support.":
    "The server did not return a signature session. Please try again or contact support.",
  "the summary of the services included": "the summary of the services included",
  "the terms and conditions of the contract": "the terms and conditions of the contract",
  "the_first_payment_of $ will_be_accounted":
    "The debit of € will only be taken when your application is accepted. This card will be used for all monthly debits.",
  "This is a long-term rental contract, which the consumer concludes with Evollis S.A.S. The consumer will first be asked to make a first payment and provide information. It is only after Evollis has evaluated this information and has definitively accepted the request, that the contract will be concluded. Evollis S.A.S. is a limited liability company under French law with its registered office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.":
    "This is a long-term rental contract, which the consumer concludes with Evollis S.A.S. The consumer will first be asked to make a first payment and provide information. It is only after Evollis has evaluated this information and has definitively accepted the request, that the contract will be concluded. Evollis S.A.S. is a limited liability company under French law with its registered office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.",
  "to product": "to product",
  "Type of residence": "Type of residence",
  "Uma factura de telemóvel com menos de 6 meses":
    "Utility, phone or internet bill in your name less than 6 months old",
  "Unable to load payment configuration. Please try again.": "Unable to load payment configuration. Please try again.",
  "Unable to start payment. Please try again.": "Unable to start payment. Please try again.",
  VatBusinessCode: "VAT number",
  warningLabel: "Warning!",
  WAY_OUT_DOCUMENT: "Product delivery form",
  "We will contact you as soon as your file is treated": "We will contact you as soon as your file is treated",
  "Wij vragen u vriendelijk een eerste betaling te doen ter waarde van de éénmalige kosten onder uw Private Lease Contract. Dat is dus":
    "We kindly ask you to make a first payment equal to the one-off fees under your Private Lease contract. That is:",
  "Without your supporting documents, your file will be canceled within 3 days.":
    "Without your supporting documents, your file will be canceled within 3 days.",
  "working Sector": "working Sector",
  yes: "Yes",
  "Your photo": "Your photo",

  /* Tenant legal mentions (i18n keys from voyager-script first-init) */
  mediamarkt_legal_mention_0:
    "Long-term rental agreement (LLD), subject to acceptance of the application by the Lessor, Evollis, a simplified joint-stock company with a share capital of €{shareCapitalFinancer}, whose registered office is located at 22-26 quai de Bacalan, 33300 Bordeaux, France, registered with the Bordeaux Trade and Companies Register under number 530 612 571, intra-Community VAT number FR 19 530612571. ADEME No.: FR320894_03JPOV.",
  mediamarkt_legal_mention_1:
    "The rental application requires an initial payment and the provision of information necessary for the assessment of the application. The rental contract will only be definitively formed after review and acceptance of the application by Evollis. In the event that Evollis refuses the rental application, any sum paid will be refunded in full as soon as possible.",
  mediamarkt_legal_mention_2: {
    propsValues: (props) => {
      const hrefPrivacy = getStaticDocUrl(
        props?.tunnelData,
        "privacy",
        "https://static-evollis.evollis.com/mediamarkt_be/en-BE/privacy.pdf"
      )
      return (
        "The personal data collected is necessary for the assessment of the application and the management of the rental agreement. " +
        "Processing carried out for these purposes is based on the performance of the contract. " +
        "Processing carried out for the purposes of marketing to partners is based on your consent, which you may withdraw at any time. " +
        "To find out more about the processing of your personal data and your rights (access, rectification, erasure, restriction, objection and portability), " +
        `you can consult the Information Notice on the protection of personal data by <a href="${hrefPrivacy}" target="_blank" rel="noopener noreferrer">clicking here</a>.`
      )
    }
  },
  mediamarkt_legal_mention_3:
    "You may also contact Evollis at the following address:\n" +
    "Evollis – Customer Service\n" +
    "22 quai de Bacalan\n" +
    "33300 Bordeaux, France\n" +
    "\n" +
    "or by email at support.mediamarkt@evollis.com",
  fnac_pt_legal_mention_0:
    "Long-term rental contract and associated services, subject to acceptance of the application by the lessor Evollis, SAS with a share capital of {shareCapitalFinancer} €. Registered office: 22-26 Quai de Bacalan, 33300 Bordeaux.",
  fnac_pt_legal_mention_1: "RCS Bordeaux no. 530 612 571 ADEME no.: FR320894 _03JPOV",
  fnac_pt_legal_mention_2:
    "Unless otherwise stated, the information requested is mandatory. The data collected are intended for Evollis, the data controller, and are used to manage your rental contract request, to enable us to offer suitable offers, and to comply with our legal and regulatory obligations. For more information on the processing of your personal data and to exercise your rights — right of access, rectification, erasure, restriction of processing, data portability, right to object (including to the use of your personal data for direct marketing purposes), and the right to organise the handling of your data after your death — you may refer to the section devoted to the Personal Data Protection Notice in your rental contract or contact us at the following address: Evollis - Customer Service - 22-26 Quai de Bacalan, 33300 Bordeaux, or by email: protectiondonnees@evollis.com"
}
